// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasDistributeSpacingHorizontal: CreateIconOptions = {
  "displayName": "FASDistributeSpacingHorizontal",
  "viewBox": "0, 0, 512, 512",
  "d": "M32 24C32 10.7 42.7 0 56 0S80 10.7 80 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24L32 24zM160 144c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-224zM456 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24z"
};
